import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, hairline, imageSlot, ornament } from "./kit";
import type { LabelTemplate } from "./types";

// Medallion: the visitor's logo inside a bronze medallion ring, the house
// name set beneath. The slot is the one uploaded image, so it is the first
// element (the back of the stack) and the ring draws after it.
function wine(): CanvasData {
  const b = "wine";
  // medallion-ring's viewBox is 117 units wide, centred on SVG (60, 60); its
  // inner ring (r 42, stroke 1.2) leaves a clear aperture of radius 41.4
  // units = 16.28 mm at 46 mm wide. The slot sits wholly inside it: a
  // 21.4 mm square's corners are 15.13 mm from the centre, 1.14 mm clear of
  // the ring (MCC, by rebottle: 1.02 mm), so even a square logo never runs
  // under it. The ring spans y 5–51; the text block is centred between its
  // foot and the footer's cap line (9.35 mm above and below).
  const slot = imageSlot({ x: 34.3, y: 17.3, width: 21.4, height: 21.4 }, "Add your logo");
  return doc(b, INK["warm-white"], [
    slot,
    ornament("medallion-ring", INK.bronze, { width: 46, at: [45, 28] }),
    centred(b, { text: "YOUR NAME", font: "cinzel", size: 5, color: INK.charcoal, baseline: 65.35, tracking: 0.2 }),
    hairline(INK.bronze, 45, 70.35, 26),
    centred(b, { text: "Private Cellar · 2026", font: "cormorant", size: 2.6, color: INK.charcoal, baseline: 76.85, tracking: 0.1 }),
    centred(b, { text: "Stellenbosch", font: "montserrat", size: 1.8, color: INK.charcoal, baseline: 88, tracking: 0.2 }),
  ]);
}

export const logoMedallion: LabelTemplate = {
  key: "logo-medallion",
  name: "Medallion",
  occasion: "classic",
  style: "Logo in a ring",
  description: "Your logo inside a bronze medallion ring, your name beneath.",
  hasImageSlot: true,
  slot: "logo",
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
